import { Center, Text } from "@mantine/core";
import classes from "./About.module.css";
import { ResumePDf } from "src/assets/index";

const resumePdfUrl: string = (ResumePDf as { default?: string })?.default ?? (ResumePDf as unknown as string);

const About = () => {
  return (
    <div className={classes["about-wrapper"]}>
      <Center style={{ flexDirection: "column" }}>
        <div className={classes.headshot} id={"headshot"}/>
        <div className={classes["title-wrapper"]}>
          <Text>
            Hey, I'm Andrew Tanaka, a platform engineer with a deep
            full-stack and architecture background - focused on cloud
            infrastructure, distributed systems, and bridging the gap between
            product vision and engineering delivery.
          </Text>
          <Text>
            Over the past 8+ years I've worked across the stack: front-end
            monoliths, backend microservices, native platforms, cloud IaC, and
            distributed systems on Azure and AWS, as well as vendor agnostic 
            containerized solutions. These days I primarily lead systems and 
            project teams while establishing architectural direction, but I'm 
            still very much hands-on: removing blockers, refining pipelines, or 
            augmenting team capacity for a big release push.
          </Text>
          <Text visibleFrom="sm">
            My leadership focus is on discovering and resolving bottlenecks
            through process & tooling optimizations and career development 
            mentorship. Early on that meant eliminating boilerplate overhead through custom
            framework additions or cutting deploy times with clever pipeline caching.
            More recently it's meant redesigning Cosmos implementations to slash RU
            consumption, or cutting annual AI spend by ~90% through P&L driven feature 
            analysis, CDN edge-caching improvements, and training engineers on efficient
            approaches to data indexing and search tooling.
          </Text>
          <Text>
            Currently I'm a Platform Engineering Manager at TEGNA, leading the
            platform and CMS domains. The platform consists of two microservice teams 
            and one devops team. These teams are multicloud and comprised of both 
            onshore and offshore developers to support 24-7 media creation, curation, 
            and delivery services. The CMS product teams, React web and Swift, offer
            internal tooling for newsroom content management serving 64 TV stations
            across 51 US markets. Outside of work you'll find me rock climbing, 
            making music, working on personal development projects, or rolling dice 
            in a 5th edition custom campaign setting.
          </Text>
          <Text>
            Thanks for stopping by; explore my work, check out my projects, or
            get in touch.
          </Text>
        </div>
        <div className={classes["links-wrapper"]}>
          {/*<a*/}
          {/*  href={"/Andrew_Tanaka_Resume.html"}*/}
          {/*  target="_blank"*/}
          {/*  rel="noopener noreferrer"*/}
          {/*>*/}
          {/*  <div className={classes["resume-text"]}>{"View R\u00E9sum\u00E9"}</div>*/}
          {/*</a>*/}
          <a href={resumePdfUrl} download="Andrew_Tanaka_Resume.pdf">
            <div className={classes["button-primary"]}>
              {"Download R\u00E9sum\u00E9"}
            </div>
          </a>
          <a href={"#contact-me"}>
            <div className={classes["button-primary"]}>{"Get in Touch"}</div>
          </a>
        </div>
      </Center>
    </div>
  );
};

export default About;
